import React from "react";
import { usePacks, type PackGroup } from "../services/packs";

const GROUP_COLOR: Record<PackGroup, string> = {
  comms: "#3b82f6",
  field: "#22c55e",
  unified: "#a855f7",
  commerce: "#06b6d4",
  enterprise: "#f59e0b",
  client: "#64748b"
};

/**
 * Renders a tenant's vertical package as a labelled pill with a group-coloured
 * dot. Resolves the slug to its label via the shared (cached) package catalog,
 * so callers only pass the slug.
 */
export function PackTag({ pack }: { pack: string | null }) {
  const { bySlug } = usePacks();
  const p = pack ? bySlug[pack] : null;
  if (!p) return <span className="pill" style={{ opacity: 0.65 }}>No package</span>;
  return (
    <span className="pill" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 8, height: 8, borderRadius: 2, background: GROUP_COLOR[p.group], flexShrink: 0 }} />
      {p.label}
    </span>
  );
}
